import { render, staticRenderFns } from "./MaleAvatar.vue?vue&type=template&id=67f3ef35&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('67f3ef35', component.options)
    } else {
      api.rerender('67f3ef35', component.options)
    }
    module.hot.accept("./MaleAvatar.vue?vue&type=template&id=67f3ef35&functional=true&", function () {
      api.rerender('67f3ef35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/MaleAvatar.vue"
export default component.exports